/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from '../../components/TableComponent';

type props = {
  columns: any;
  rows: any;
  hidden: string[];
  page?: number;
  loading?: boolean;
  handlePageChange?: (event: any, newPage: number) => void;
  count?: number;
};

const BlogsList = ({ rows, columns, hidden, count, loading, handlePageChange, page }: props) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item: any) => !hidden.includes(item.field))}
          rows={rows}
          count={count}
          page={page}
          loading={loading}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default BlogsList;
